import { takeLatest, take, put } from 'redux-saga/effects';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { consts as commentsList } from './commentsList';
import { consts as postDetails } from './postDetails';
import { consts as postsList } from './postsList';

export const consts = createReqConsts('communities', 'postComment');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'posts',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['postId'],
    },
    'comments',
  ],
});

export default createReqReducer(consts);

function* postCommentWorker(action) {
  const { parentId, postId } = action.payload;
  const succeedAction = yield take(consts.SUCCEED);

  yield put({
    type: commentsList.ADD_COMMENT,
    payload: {
      ...succeedAction.payload,
      parentId,
    },
  });

  yield put({
    type: postDetails.ADD_COMMENT,
  });

  yield put({
    type: postsList.POST_COMMENTS_CHANGED,
    payload: {
      postId,
      change: 1,
    },
  });
}

export function* postCommentSaga() {
  yield takeLatest(consts.SEND, postCommentWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/postComment.js